import { ROUTE_NAMES } from '../app/constants/routes';

export enum Locale {
    CS = 'cs',
    DE = 'de',
    EN = 'en',
    ES = 'es',
    FR = 'fr',
    IT = 'it',
    NL = 'nl',
    PL = 'pl',
    PT = 'pt',
    RO = 'ro',
    RU = 'ru',
}

const LOCALE_ISO_MAP = {
    [Locale.CS]: 'cs-CS',
    [Locale.DE]: 'de-DE',
    [Locale.EN]: 'en-GB',
    [Locale.ES]: 'es-ES',
    [Locale.FR]: 'fr-FR',
    [Locale.IT]: 'it-IT',
    [Locale.NL]: 'nl-NL',
    [Locale.PL]: 'pl-PL',
    [Locale.PT]: 'pt-PT',
    [Locale.RO]: 'ro-RO',
    [Locale.RU]: 'ru-RU',
};

export const locales = Object.values(Locale).map(code => ({ code, language: LOCALE_ISO_MAP[code] }));

export const defaultLocale = Locale.EN;

export const i18nCustomPages = {
    [ROUTE_NAMES.ACCOUNT_YOUR_DIRECT_SALES]: {
        cs: '/account/your-buy-now',
        de: '/account/your-buy-now',
        en: '/account/your-buy-now',
        es: '/account/your-buy-now',
        fr: '/account/your-buy-now',
        it: '/account/your-buy-now',
        nl: '/account/your-buy-now',
        pl: '/account/your-buy-now',
        pt: '/account/your-buy-now',
        ro: '/account/your-buy-now',
        ru: '/account/your-buy-now',
    },
    [ROUTE_NAMES.AUCTION_DETAIL]: {
        cs: '/aukce/dp/[slug]',
        de: '/auktionen/dp/[slug]',
        en: '/auctions/dp/[slug]',
        es: '/subastas/dp/[slug]',
        fr: '/ventes-aux-encheres/dp/[slug]',
        it: '/aste/dp/[slug]',
        nl: '/veilingen/dp/[slug]',
        pl: '/aukcje/dp/[slug]',
        pt: '/leiloes/dp/[slug]',
        ro: '/licitati/dp/[slug]',
        ru: '/auktsiony/dp/[slug]',
    },
    [ROUTE_NAMES.AUCTION_DETAIL_NEGOTIATION]: {
        cs: '/aukce/dp/[slug]/jednani',
        de: '/auktionen/dp/[slug]/verhandlung',
        en: '/auctions/dp/[slug]/negotiation',
        es: '/subastas/dp/[slug]/negociacion',
        fr: '/ventes-aux-encheres/dp/[slug]/negociation',
        it: '/aste/dp/[slug]/negoziazione',
        nl: '/veilingen/dp/[slug]/onderhandeling',
        pl: '/aukcje/dp/[slug]/negocjacja',
        pt: '/leiloes/dp/[slug]/negociacao',
        ro: '/licitati/dp/[slug]/negociere',
        ru: '/auktsiony/dp/[slug]/peregovory',
    },
    [ROUTE_NAMES.AUCTION_LISTING]: {
        cs: '/aukce/[localizedAssetType]/[...optionalParams]',
        de: '/auktionen/[localizedAssetType]/[...optionalParams]',
        en: '/auctions/[localizedAssetType]/[...optionalParams]',
        es: '/subastas/[localizedAssetType]/[...optionalParams]',
        fr: '/ventes-aux-encheres/[localizedAssetType]/[...optionalParams]',
        it: '/aste/[localizedAssetType]/[...optionalParams]',
        nl: '/veilingen/[localizedAssetType]/[...optionalParams]',
        pl: '/aukcje/[localizedAssetType]/[...optionalParams]',
        pt: '/leiloes/[localizedAssetType]/[...optionalParams]',
        ro: '/licitati/[localizedAssetType]/[...optionalParams]',
        ru: '/auktsiony/[localizedAssetType]/[...optionalParams]',
    },
    [ROUTE_NAMES.DIRECT_SALE_DETAIL]: {
        cs: '/okamzity-nakup/dp/[slug]',
        de: '/sofortkauf/dp/[slug]',
        en: '/buy-now/dp/[slug]',
        es: '/compra-ahora/dp/[slug]',
        fr: '/achat-immediat/dp/[slug]',
        it: '/compra-subito/dp/[slug]',
        nl: '/nu-kopen/dp/[slug]',
        pl: '/kup-teraz/dp/[slug]',
        pt: '/compra-imediata/dp/[slug]',
        ro: '/cumpara-acum/dp/[slug]',
        ru: '/kupit-seychas/dp/[slug]',
    },
    [ROUTE_NAMES.DIRECT_SALE_DETAIL_NEGOTIATION]: {
        cs: '/okamzity-nakup/dp/[slug]/jednani',
        de: '/sofortkauf/dp/[slug]/verhandlung',
        en: '/buy-now/dp/[slug]/negotiation',
        es: '/compra-ahora/dp/[slug]/negociacion',
        fr: '/achat-immediat/dp/[slug]/negociation',
        it: '/compra-subito/dp/[slug]/negoziazione',
        nl: '/nu-kopen/dp/[slug]/onderhandeling',
        pl: '/kup-teraz/dp/[slug]/negocjacja',
        pt: '/compra-imediata/dp/[slug]/negociacao',
        ro: '/cumpara-acum/dp/[slug]/negociere',
        ru: '/kupit-seychas/dp/[slug]/peregovory',
    },
    [ROUTE_NAMES.DIRECT_SALE_LISTING]: {
        cs: '/okamzity-nakup/[localizedAssetType]/[...optionalParams]',
        de: '/sofortkauf/[localizedAssetType]/[...optionalParams]',
        en: '/buy-now/[localizedAssetType]/[...optionalParams]',
        es: '/compra-ahora/[localizedAssetType]/[...optionalParams]',
        fr: '/achat-immediat/[localizedAssetType]/[...optionalParams]',
        it: '/compra-subito/[localizedAssetType]/[...optionalParams]',
        nl: '/nu-kopen/[localizedAssetType]/[...optionalParams]',
        pl: '/kup-teraz/[localizedAssetType]/[...optionalParams]',
        pt: '/compra-imediata/[localizedAssetType]/[...optionalParams]',
        ro: '/cumpara-acum/[localizedAssetType]/[...optionalParams]',
        ru: '/kupit-seychas/[localizedAssetType]/[...optionalParams]',
    },
    [ROUTE_NAMES.SMART_LINK_VEHICLE]: false,
    [ROUTE_NAMES.SELL]: {
        cs: '/prodat',
        de: '/verkaufen',
        en: '/sell',
        es: '/vender',
        fr: '/vendre',
        it: '/vendi',
        nl: '/verkopen',
        pl: '/sprzedawaj',
        pt: '/vender',
        ro: '/vinde',
        ru: '/продать',
    },
    [ROUTE_NAMES.HOW_TO_HOW_SELL_USED_BUS]: {
        cs: '/navody/jak-prodat-pouzity-autobus',
        de: '/ratgeber/wie-gebrauchten-bus-verkaufen',
        en: '/how-to/how-sell-used-bus',
        es: '/guias/como-vender-autobus-usado',
        fr: '/guides/comment-vendre-bus-occasion',
        it: '/guide/come-vendere-autobus-usato',
        nl: '/gidsen/hoe-gebruikte-bus-verkopen',
        pl: '/poradniki/jak-sprzedac-uzywany-autobus',
        pt: '/guias/como-vender-autocarro-usado',
        ro: '/ghiduri/cum-sa-vinzi-autobuz-second-hand',
        ru: '/rukovodstva/kak-prodat-avtobus-bu',
    },
    [ROUTE_NAMES.HOW_TO_REASONS_BUY_BUS_AUCTION]: {
        cs: '/navody/duvody-k-nakupu-autobusu-v-drazbe',
        de: '/ratgeber/gruende-bus-auktion-kaufen',
        en: '/how-to/reasons-buy-bus-auction',
        es: '/guias/razones-comprar-autobus-subasta',
        fr: '/guides/raisons-acheter-bus-enchere',
        it: '/guide/motivi-per-acquistare-autobus-asta',
        nl: '/gidsen/redenen-bus-kopen-veiling',
        pl: '/poradniki/powody-zakupu-autobusu-na-aukcji',
        pt: '/guias/razoes-comprar-autocarro-leilao',
        ro: '/ghiduri/motive-cumparare-autobuz-licitatie',
        ru: '/rukovodstva/prichiny-kupit-avtobus-na-aukcione',
    },
    [ROUTE_NAMES.HOW_TO_GUIDE_BUY_USED_BUS]: {
        cs: '/navody/pruvodce-koupi-pouziteho-autobusu',
        de: '/ratgeber/leitfaden-gebrauchten-bus-kaufen',
        en: '/how-to/guide-buy-used-bus',
        es: '/guias/guia-compra-autobus-usado',
        fr: '/guides/guide-achat-bus-occasion',
        it: '/guide/guida-acquisto-autobus-usato',
        nl: '/gidsen/gids-gebruikte-bus-kopen',
        pl: '/poradniki/poradnik-zakupu-uzywanego-autobusu',
        pt: '/guias/guia-compra-autocarro-usado',
        ro: '/ghiduri/ghid-cumparare-autobuz-second-hand',
        ru: '/rukovodstva/gid-po-pokupke-avtobusa-bu',
    },
    [ROUTE_NAMES.HOW_TO_TRUST_REPORT]: {
        cs: '/navody/trust-report',
        de: '/ratgeber/trust-report',
        en: '/how-to/trust-report',
        es: '/guias/trust-report',
        fr: '/guides/trust-report',
        it: '/guide/trust-report',
        nl: '/gidsen/trust-report',
        pl: '/poradniki/trust-report',
        pt: '/guias/trust-report',
        ro: '/ghiduri/trust-report',
        ru: '/rukovodstva/trust-report',
    },
    [ROUTE_NAMES.IMPRESSUM]: {
        cs: false,
        de: '/impressum',
        en: false,
        es: false,
        fr: false,
        it: false,
        nl: false,
        pl: false,
        pt: false,
        ro: false,
        ru: false,
    },
    [ROUTE_NAMES.STORYBLOK_PREVIEW]: false,
} as const;
